export default function Cookies() {
  return (
    <section className="max-w-5xl mx-auto px-4 py-12 space-y-8">
      <header className="space-y-2">
        <h1 className="text-3xl font-extrabold">Cookie Policy</h1>
        <p className="text-neutral-300">
          The website <strong>2Getters.com</strong> uses cookies only to the extent strictly necessary
          for the proper functioning of the site.
        </p>
      </header>

      <div className="rounded-2xl border border-neutral-800 p-6 space-y-3">
        <h2 className="text-xl font-semibold">1. What are cookies?</h2>
        <p className="text-sm text-neutral-300">
          Cookies are small text files stored on your device when you access a website. They are generally
          used to ensure the technical functionality of the site or to improve the user experience.
        </p>
      </div>

      <div className="rounded-2xl border border-neutral-800 p-6 space-y-3">
        <h2 className="text-xl font-semibold">2. Types of cookies used</h2>
        <p className="text-sm text-neutral-300">
          This website uses only <strong>essential cookies</strong>, which allow the site to load and function properly.
        </p>
        <p className="text-sm text-neutral-300">We do <strong>not</strong> use cookies for:</p>
        <ul className="list-disc pl-5 text-sm text-neutral-300 space-y-1">
          <li>traffic analysis (e.g., Google Analytics),</li>
          <li>advertising,</li>
          <li>profiling or tracking visitors.</li>
        </ul>
      </div>

      <div className="rounded-2xl border border-neutral-800 p-6 space-y-3">
        <h2 className="text-xl font-semibold">3. Managing cookies</h2>
        <p className="text-sm text-neutral-300">
          Most browsers allow you to control cookies through their settings. You can delete or block cookies at any
          time, but this may affect the proper functioning of the website.
        </p>
      </div>

      <div className="rounded-2xl border border-neutral-800 p-6 space-y-3">
        <h2 className="text-xl font-semibold">4. Updates</h2>
        <p className="text-sm text-neutral-300">
          This cookies policy may be updated if we introduce new services that use cookies (for example, Google
          Analytics or embedded video content). Any changes will be published on this page.
        </p>
      </div>
    </section>
  );
}
